import { getCardByName } from "@/Cards";
import { iso8601ToDate } from "@/utils/iso8601ToDate";
import { CardDomain } from "./Card";

export interface ChooseLuckyCardScreenDataDto {
  luckyCard: {
    id: number;
    name: string;
  } | null;
  deck:
    | {
        id: number;
        name: string;
      }[]
    | null;
  resetDate: string | null;
  deckLength: number | null;
  luckyCardIndex: number | null;
  selectedLuckyCardIndex: number | null;
  selectedCard: {
    id: number;
    name: string;
  } | null;
}

export const mapChooseLuckyCardScreenDataDtoToDomain = (
  dto: ChooseLuckyCardScreenDataDto
): ChooseLuckyCardScreenDataDomain => {
  return {
    luckyCard: dto.luckyCard ? getCardByName(dto.luckyCard.name) : null,
    deck: dto.deck
      ? dto.deck
          .map((card) => getCardByName(card.name))
          .filter((card) => card !== null)
      : [],
    resetDate: iso8601ToDate(dto.resetDate),
    deckLength: dto.deckLength,
    luckyCardIndex: dto.luckyCardIndex,
    selectedLuckyCardIndex: dto.selectedLuckyCardIndex,
    selectedCard: dto.selectedCard
      ? getCardByName(dto.selectedCard.name)
      : null,
  };
};

export interface ChooseLuckyCardScreenDataDomain {
  luckyCard: CardDomain | null;
  deck: CardDomain[] | null;
  resetDate: Date | null;
  deckLength: number | null;
  luckyCardIndex: number | null;
  selectedLuckyCardIndex: number | null;
  selectedCard: CardDomain | null;
}
